<template>
  <div class="form-check form-switch pl-0" :class="$attrs.class">
    <label v-if="label" class="form-label mb-5">{{ label }}:</label>

    <input 
      :id="id" 
      ref="input" 
      v-bind="{ ...$attrs, class: null }" 
      class="form-check-input appearance-none w-9 mr-1 rounded-full float-left h-5 align-top bg-no-repeat bg-contain bg-gray-300 focus:outline-none cursor-pointer shadow-sm" 
      type="checkbox" 
      role="switch" 
      v-model="value" />
    
    <label class="form-check-label inline-block" :for="id">
      <span>{{ value ? labelChecked : labelUnchecked }}</span>
    </label>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>

import { ref, watch } from 'vue';
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `switch-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    labelChecked: String,
    labelUnchecked: String,
    modelValue: Boolean,
  },
  
  emits: ['update:modelValue'],

  setup( props, ctx ) {
    const value = ref( props.modelValue )

    watch( value, () => ctx.emit( 'update:modelValue', value ) )

    return { value }
  },
}
</script>
